export default __webpack_public_path__ + "static/media/3-4.2b247f5a.jpg";